// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"NewProductsCategoriesScreen_tableContainer__gApmd","table":"NewProductsCategoriesScreen_table__35V-O","input":"NewProductsCategoriesScreen_input__aaB6G"};